import React from 'react';
import BackButton from '../components/BackButton';
import VolatilityIsSignal from '../components/VolatilityIsSignal';

function VolatilityIsSignalPage() {
  return (
    <>
      <BackButton />
      <VolatilityIsSignal />
    </>
  );
}

export default VolatilityIsSignalPage;
